// extracted by mini-css-extract-plugin
module.exports = {"trailingLink__container":"styles_trailingLink__container__Wj3mC","trailingLink__link":"styles_trailingLink__link__2VFwL","trailingLink":"styles_trailingLink__uXKWx"};